import React from 'react';

export function hashStringToHue(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % 360;
}

function initialsFrom(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || parts[0] === '') return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

export interface AvatarProps {
  name: string;
  src?: string;
  size?: 24 | 32 | 40 | 56 | 80 | 88;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({ name, src, size = 32, className = '' }) => {
  const hue = hashStringToHue(name);
  const bg = `hsl(${hue}, 50%, 55%)`;
  const style = { width: `${size}px`, height: `${size}px` };

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={style}
        className={`rounded-full object-cover border border-border ${className}`}
      />
    );
  }

  const fontSize = size <= 24 ? 'text-[10px]' : size <= 32 ? 'text-xs' : size <= 40 ? 'text-sm' : 'text-2xl';

  return (
    <div
      style={{ ...style, backgroundColor: bg }}
      className={`rounded-full flex items-center justify-center text-white font-semibold border border-border ${fontSize} ${className}`}
      aria-label={name}
    >
      {initialsFrom(name)}
    </div>
  );
};
